export const baseURL = "https://admin.onlytrends.market/";
export const secretKey = "LfeLqfhmgRqACMaueFRiCDH5Tk7s8tWB";
export const projectName = "OnlyTrends";
